<script>
import RevokeConfirmationDialog from '@/src/components/revoke-confirmation-dialog.vue'
import { healthRecordService } from '@/src/services/safehaven/HealthRecordService'
import moment from 'moment'

export default {
  name: 'SharedHrList',
  page: {
    title: 'Shared Health Records',
    meta: [{ name: 'description', content: 'The Shared Health Records page.' }],
  },
  components: { RevokeConfirmationDialog },
  data() {
    return {
      selected: null,
      loading: false,
      selectedOption: 'email',
      options: [
        {
          value: 'email',
          label: 'Shared via email',
        },
        {
          value: 'QR',
          label: 'Shared via QR code',
        },
      ],
      headers: [
        {
          text: 'RECIPIENT NAME',
          align: 'start',
          value: 'recipient_name',
        },
        { text: 'DATE SHARED', value: 'record_date' },
        { text: 'ACCESS EXPIRES', value: 'hr_expiration_date_time' },
        { text: '', value: 'action' },
      ],
      revokeDialog: false,
      data: [],
    }
  },
  watch: {
    selectedOption(newValue) {
      return newValue === 'email'
        ? this.getSahredData()
        : this.getQRSharedData()
    },
  },
  created() {
    this.getSahredData()
  },
  methods: {
    async getSahredData() {
      try {
        this.loading = true
        this.data = []
        const healthRecords = (
          await healthRecordService.getSaharedHealthRecord()
        ).data
        this.loading = false
        this.data = healthRecords.response
        this.data.map((meeting) => {
          meeting.accessExpires = moment(
            meeting.hr_expiration_date_time
          ).format('MM/DD/yyyy')
          meeting.record_date = moment(meeting.record_date).format('MM/DD/yyyy')
          meeting.expired =
            new Date() > new Date(meeting.hr_expiration_date_time)
          meeting.revoke =
            new Date(meeting.hr_expiration_date_time) > new Date() &&
            !meeting.is_access_revoked
          meeting.hr_expiration_date_time = moment(
            meeting.hr_expiration_date_time
          ).format('MM/DD/yyyy')
        })
      } catch (error) {
        this.loading = false
        console.warn(error)
      }
    },

    getQRSharedData() {
      this.data = []
      healthRecordService.getSharedRecordByQRCode().then((res) => {
        this.loading = false
        this.data = res.data.response
        this.data.map((meeting) => {
          meeting.accessExpires = moment(
            meeting.hr_expiration_date_time
          ).format('MM/DD/yyyy')
          meeting.record_date = moment(meeting.record_date).format('MM/DD/yyyy')
          meeting.expired =
            new Date() > new Date(meeting.hr_expiration_date_time)
          meeting.revoke =
            new Date(meeting.hr_expiration_date_time) > new Date() &&
            !meeting.is_access_revoked
          meeting.hr_expiration_date_time = moment(
            meeting.hr_expiration_date_time
          ).format('MM/DD/yyyy')
        })
      })
    },

    revokePopup(item) {
      this.selected = item
      this.revokeDialog = true
    },
    async closeRevokeDialog(action) {
      if (action === 'yes') {
        this.revokeDialog = false
        try {
          var obj = {
            record_id: this.selected.record_id,
            is_access_revoked: 'True',
          }
          this.loading = true

          const healthRecords = (await healthRecordService.revokeAccess(obj))
            .data
          if (healthRecords) {
            this.loading = false
            this.getSahredData()
          }
        } catch (error) {
          this.loading = false
          console.warn(error)
        }
      } else {
        this.revokeDialog = false
        this.selected = null
      }
    },
  },
}
</script>

<template>
  <div>
    <v-radio-group v-model="selectedOption" row>
      <v-radio
        v-for="(option, index) in options"
        :key="index + '-' + option.value"
        :label="option.label"
        :value="option.value"
      ></v-radio>
    </v-radio-group>
    <template>
      <v-card width="100%" color="offwhite" outlined rounded="lg" loading>
        <template slot="progress">
          <v-progress-linear
            v-if="loading"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <div v-else :class="$style.loaderPlaceholder"></div>
        </template>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="data"
        class="elevation-1"
        :class="$style.sharedDocTable"
        disable-pagination
        :hide-default-footer="true"
        item-key="receipentName"
      >
        <template v-slot:[`item.hr_expiration_date_time`]="{ item }">
          <div
            :class="[
              item.is_access_revoked ||
              (item.expired && item.hr_expiration_date_time !== 'Invalid date')
                ? $style.strikeThrough
                : '',
              item.hr_expiration_date_time === 'Invalid date' ? 'pl-8' : '',
            ]"
          >
            {{
              item.hr_expiration_date_time !== 'Invalid date'
                ? item.hr_expiration_date_time
                : '--'
            }}
          </div>
        </template>
        <template v-slot:[`item.recipient_name`]="{ item }">
          <div
            :class="[
              item.is_access_revoked ||
              (item.expired && item.hr_expiration_date_time !== 'Invalid date')
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ item.recipient_name }}
          </div>
        </template>
        <template v-slot:[`item.accessExpires`]="{ item }">
          <div
            :class="[
              item.is_access_revoked ||
              (item.expired && item.hr_expiration_date_time !== 'Invalid date')
                ? $style.strikeThrough
                : '',
            ]"
          >
            {{ item.accessExpires }}
          </div>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <div class="text-center">
            <v-btn
              v-if="item.is_access_revoked"
              class="text-capitalize"
              text
              color="error"
            >
              Revoked
            </v-btn>

            <v-btn
              v-else-if="
                item.expired && item.hr_expiration_date_time !== 'Invalid date'
              "
              class="text-capitalize"
              text
              color="error"
            >
              Expired
            </v-btn>
            <v-btn
              v-else-if="item.revoke"
              class="ma-2 text-capitalize"
              rounded
              outlined
              color="#0476D9"
              @click="revokePopup(item)"
            >
              Revoke
            </v-btn>

            <v-btn
              v-else
              class="ma-2 text-capitalize"
              rounded
              outlined
              color="#0476D9"
              @click="revokePopup(item)"
            >
              Revoke
            </v-btn>
          </div>
        </template>

        <template v-slot:no-data>
          <h3 class="ma-6 subtitle-1 text-center"
            >Your records are not being shared with anyone</h3
          >
        </template>
      </v-data-table>
      <RevokeConfirmationDialog
        v-if="selected"
        :dialog="revokeDialog"
        :item="selected"
        @closeRevokeDialog="closeRevokeDialog"
      ></RevokeConfirmationDialog>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.textHa6 {
  font-size: 18px !important;
}
.buttonTextBold {
  font-weight: bold !important;
}
.sharedDocTable {
  padding: 0 15px 10px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.my-header-style,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 11px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

.sharedDocTableBody tr td {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: #454648 !important;
  letter-spacing: 0.15px;
}
.sharedDocTableFont {
  font-weight: 600;
  color: #454648 !important;
  text-decoration: none;
}
tbody {
  tr:hover {
    background-color: #f2f9ff !important;
  }
}

.strikeThrough {
  text-decoration: line-through;
  text-decoration-color: #6e6d6d;
}
</style>

<style scoped>
/deep/ .v-data-table__wrapper thead.v-data-table-header tr th.sortable span {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #aaa !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
/deep/ .theme--light.v-data-table {
  min-height: 100px !important;
  max-height: 400px !important;
  overflow: auto !important;
}
.providerTableFont {
  text-decoration: none;
}
</style>
